import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { metaDataService } from "@/services/api/cresivoxServer";
import { REDUCER_NAME, iMetaDataDTO } from './Type';

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addMetaData = createAsyncThunk<
    iGenericResponse<any | null> | null,
    iMetaDataDTO,
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("addMetaData"),
     // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async (payload, { rejectWithValue }) => {
        try {
            //@ts-ignore
            const response = await metaDataService.addMetaData(payload);
            if (response) {
                const { httpStatusCode, data, message } = response;
                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data: {
                                    data: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong while adding metadata",
            });
        }
    },
);

export const updateMetaData = createAsyncThunk<
    iGenericResponse<any | null> | null,
    { metaId: string; data: iMetaDataDTO },
    {
        rejectValue: iStateMessage;
    }
>(
    curriedGetThunkName("updateMetaData"),
     // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
    async ({ metaId, data }, { rejectWithValue }) => {
        try {
            //@ts-ignore
            const response = await metaDataService.updateMetaData(metaId, data);
            if (response) {
                const { httpStatusCode, data, message } = response;
                switch (httpStatusCode) {
                    case httpStatusCodes.SUCCESS_OK: {
                        if (data && data.data) {
                            return {
                                data: {
                                    data: data.data,
                                    message,
                                }
                            };
                        } else {
                            return rejectWithValue({
                                httpStatusCode,
                                message,
                            });
                        }
                    }
                    default: {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
            } else {
                return rejectWithValue({
                    message: "No response received",
                });
            }
        } catch (error) {
            return rejectWithValue({
                message: "Something went wrong while updating metadata",
            });
        }
    },
);

export const getMetaData = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getMetaData"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (_, { rejectWithValue }) => {

    try {
      const response = await metaDataService.getMetaData();


      if (response) {
        const { httpStatusCode, data, message } = response;


        if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
          return {
            data: {
              data: data.data,
              message,
            },
          };
        }

        return rejectWithValue({ httpStatusCode, message });
      }

      return rejectWithValue({ message: "No response received" });
    } catch (error) {
      console.error("🔥 getMetaData ERROR:", error);
      return rejectWithValue({
        message: "Something went wrong while fetching metadata",
      });
    }
  }
);

